import React, { Fragment, useState, useEffect, useCallback, useRef } from 'react';
import T from 'prop-types';
import { isEqual, get } from 'lodash-es';

import AddAppComponent from './AddAppComponent';
import { AppsListMobile } from './AppsList';

const AppsSelectionMobile = ({
  appsSelected = [],
  preSelectedApp = [],
  selectionForbidden,
  onChange,
  onNextStepClick,
  onForbiddenStatusChange,
}) => {
  const [selectedApps, setSelectedApps] = useState(appsSelected.length ? appsSelected : preSelectedApp);
  const [placeholderSelected, setPlaceholderSelected] = useState(null);

  const searchTypeaheadMobile = useRef();

  const disabledNextStep = selectedApps.length < 3;
  const placeholders = (selectedApps.length === 0 || isEqual(selectedApps, preSelectedApp))
    ? null : selectedApps.length;

  const instance = () => get(searchTypeaheadMobile, 'current', 'typeaheadInstance()');

  useEffect(() => {
    onChange(selectedApps);
    setPlaceholderSelected(placeholders);
  }, [selectedApps]);

  const typeaheadFocus = useCallback(() => {
    const searchInput = document.querySelector('.rbt-input-hint');
    searchInput.classList.add('pulse-box-blue-bg');
    setTimeout(() => {
      searchInput.classList.remove('pulse-box-blue-bg');
    }, 1000);
    instance().focus();
  }, []);

  const typeaheadBlur = useCallback(() => {
    setPlaceholderSelected(null);
    if (instance().length) instance().blur();
  }, []);

  const handleAppRemove = useCallback((refNo) => {
    setSelectedApps(prevApps => prevApps.filter(({ ref_no }) => ref_no !== refNo));
    typeaheadFocus();
  }, []);

  const handleNextClick = () => {
    if (!disabledNextStep) onNextStepClick('userReportForm', false);
  };

  const handlePlaceholderClick = (id) => {
    setPlaceholderSelected(id);
    typeaheadFocus();
  };

  const handleFocus = () => {
    if (placeholders) setPlaceholderSelected(selectedApps.length);
  };

  return (
    <Fragment>
      <div className="app-selection-mobile-container">
        <h6 className="app-selection-mobile-title">Find Competitor Apps</h6>

        <AddAppComponent
          selectedApps={selectedApps}
          selectionForbidden={selectionForbidden}
          onChange={setSelectedApps}
          onForbiddenStatusChange={onForbiddenStatusChange}
          searchTypeaheadMobileRef={searchTypeaheadMobile}
          onBlur={typeaheadBlur}
          onFocus={handleFocus}
        />

        <AppsListMobile
          apps={selectedApps}
          onAppRemove={handleAppRemove}
          onPlaceholderClick={handlePlaceholderClick}
          placeholderSelected={placeholderSelected}
          preSelectedApp={preSelectedApp}
        />

        <button
          type="button"
          className="btn app-selection-mobile-button"
          disabled={disabledNextStep}
          onClick={handleNextClick}
        >
          Get My Free Report
        </button>
      </div>

    </Fragment>
  );
};

AppsSelectionMobile.propTypes = {
  appsSelected: T.array.isRequired,
  preSelectedApp: T.array.isRequired,
  selectionForbidden: T.bool.isRequired,
  onChange: T.func.isRequired,
  onNextStepClick: T.func.isRequired,
  onForbiddenStatusChange: T.func.isRequired,
};

export default AppsSelectionMobile;
